import { render } from "./menu_master.vue?vue&type=template&id=20422102&scoped=true"
import script from "./menu_master.vue?vue&type=script&lang=js"
export * from "./menu_master.vue?vue&type=script&lang=js"

import "./menu_master.vue?vue&type=style&index=0&id=20422102&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20422102"]])

export default __exports__